module.exports = __webpack_public_path__ + "bz.svg?2ffc1803cea6e1e68c5fa06a1eda1383";